import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { IFinalResponse } from '_core/types';
import { HeadlessDeliveryTypes } from '../Types';

const machine = Machines.onHeadlessDelivery.machine;

// Este serviço é parecido com o findHeadlessDelivery, porém tenta deixar os parametros de entrada como argumento
export const getHeadlessDelivery = (
  keys: string[],
  fields?: string[],
): Promise<IFinalResponse> => {
  const filter: HeadlessDeliveryTypes.HeadlessDeliverySearchType[] = keys.map(
    (value) => {
      return {
        param: 'friendlyUrlPath',
        conditional: 'eq',
        value,
      };
    },
  );

  return callServiceMachine(machine, {
    flatter: true,
    filter,
    fields,
  });
};

export default { getHeadlessDelivery };
